import React, { useState, useEffect } from 'react';
import FilterComponents from '../FilterComponents.tsx';
import CustomDataGrid from '../../../components/CustomDataGrid/CustomDataGrid.tsx';
import LoadingView from '../../../components/LoadingView/LoadingView.js'; // your custom loader

function InventoryView(props) {
  const [loading, setLoading] = useState(false);

  const columns = [
    { field: 'item', headerName: 'Item', flex: 1 },
    { field: 'quantity', headerName: 'Quantity', flex: 1 },
    { field: 'schedule', headerName: 'Schedule', flex: 1 }
  ];

  const dataRows = [
    { id: 1, item: 'Chicken cheese burger', quantity: "1000", schedule: "Per Day" },
    { id: 2, item: 'Chicken cheese burger', quantity: "500", schedule: "Sat-Sunday" },
  ];

  // Simulate data fetching
  useEffect(() => {
    setLoading(true); // show loading
    const timer = setTimeout(() => setLoading(false), 1000); // hide after 2s
    return () => clearTimeout(timer);
  }, []);

  return (
    <div style={{ padding: '1rem' }}>
      {/* Your custom LoadingView */}
      <LoadingView open={loading} close={() => setLoading(false)} />

      {/* Render table and filters only when loading is false */}
      {!loading && (
        <div>
          <FilterComponents title="OK" isItem={17} />
          <CustomDataGrid columns={columns} dataRows={dataRows} />
        </div>
      )}
    </div>
  );
}

export default InventoryView;
